Wee.fn.extend('commerce', {
	/**
	 * Add an item to the cart via ajax
	 *
	 * @param {object} options
	 * @param {string} [options.selector=ref:addToCart]
	 * @param {string} [options.buttonSelector=ref:addToCartBtn]
	 * @param {string} [options.disabledClass=-is-disabled]
	 * @param {string} [options.loadingText=Processing...]
	 * @param {(Array|function|string)} [options.submit] - callback on form submission
	 * @param {(Array|function|string)} [options.success] - callback if request succeeds
	 * @param {(Array|function|string)} [options.error] - callback if request fails
	 */
	initAddToCart: function(options) {
		var priv = this.$private,
			settings = $.extend({
				selector: 'ref:addToCart',
				buttonSelector: 'ref:addToCartBtn',
				disabledClass: '-is-disabled',
				loadingText: 'Processing...'
			}, options),
			submitCallback = settings.submit,
			successCallback = settings.success,
			errorCallback = settings.error;

		$(settings.selector).on('submit', function(e, el) {
			var $el = $(el),
				$btn = $el.find(settings.buttonSelector),
				originalText = $btn.text();

			if (submitCallback) {
				submitCallback();
			}

			if ($btn.length) {
				$btn.prop('disabled', true)
					.addClass(settings.disabledClass)
					.text(settings.loadingText);
			}

			priv.post({
				data: $el.serialize(),
				success: function(response) {
					var $qty = $el.find('input[name="qty"]');

					if ($qty.length) {
						$qty.val($qty[0].hasAttribute('data-qty') ? $qty.data('qty') : '1')
							.trigger('change');
					}

					if ($btn.length) {
						$btn.prop('disabled', false)
							.removeClass(settings.disabledClass)
							.text(originalText);
					}

					if (response.success) {
						$.set('cart', priv.transform(response.cart));

						if (successCallback) {
							successCallback(response);
						}
					}

					if (response.error && errorCallback) {
						errorCallback(response);
					}
				},
				error: function(error) {
					if (errorCallback) {
						errorCallback(error);
					}
				}
			});

			e.preventDefault();
		}, {
			namespace: 'commerceAddToCart'
		});
	},

	/**
	 * Destroy add to cart events
	 */
	destroyAddToCart: function() {
		$.events.off(false, '.commerceAddToCart');
	},

	/**
	 * Init mini cart app
	 *
	 * @param {object} options
	 * @param {string} [options.selector=ref:miniCart]
	 * @param {string} [options.view=commerce.mini-cart]
	 * @param {object} [options.model={}]
	 */
	initMiniCart: function(options) {
		$.app.make('miniCart', $.extend({
			target: 'ref:miniCart',
			view: 'commerce.mini-cart',
			model: {}
		}, options));
	},

	/**
	 * Init cart totals app
	 *
	 * @param {object} options
	 * @param {string} [options.selector=ref:cartTotals]
	 * @param {string} [options.view=commerce.cart-totals]
	 * @param {object} [options.model={}]
	 */
	initCartTotals: function(options) {
		$.app.make('cartTotals', $.extend({
			target: 'ref:cartTotals',
			view: 'commerce.cart-totals',
			model: {}
		}, options));
	},

	/**
	 * Remove an item from cart
	 *
	 * @param {object} options
	 * @param {string} [options.itemSelector=ref:cartItem]
	 * @param {string} [options.formSelector=ref:removeCartItem]
	 * @param {(Array|function|string)} [options.submit] - callback on form submission
	 * @param {(Array|function|string)} [options.success] - callback if request succeeds
	 * @param {(Array|function|string)} [options.error] - callback if request fails
	 */
	initRemoveItem: function(options) {
		var priv = this.$private,
			settings = $.extend({
				itemSelector: 'ref:cartItem',
				formSelector: 'ref:removeCartItem'
			}, options),
			submitCallback = settings.submit,
			successCallback = settings.success,
			errorCallback = settings.error;

		$(settings.formSelector).on('submit', function(e, el) {
				var $el = $(el);

				if (submitCallback) {
					submitCallback();
				}

				priv.post({
					data: $el.serialize(),
					success: function(response) {
						if (response.success) {
							$.set('cart', priv.transform(response.cart));

							$el.closest(settings.itemSelector).remove();

							if (successCallback) {
								successCallback(response);
							}
						}

						if (response.error && errorCallback) {
							errorCallback(response);
						}
					},
					error: function(error) {
						if (errorCallback) {
							errorCallback(error);
						}
					}
				});

				e.preventDefault();
			}, {
				namespace: 'commerceRemoveItem'
			});
	},

	/**
	 * Destroy remove item events
	 */
	destroyRemoveItem: function() {
		$.events.off(false, '.commerceRemoveItem');
	}
});